import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { MonitoringModule } from '../monitoring/monitoring.module';

import { HelpComponent } from './help.component';
import { SupportedBrowsersComponent } from './supported-browsers/supported-browsers.component';
import { ContactComponent } from './contact/contact.component';
import { UnsupportedBrowserComponent } from './unsupported-browser/unsupported-browser.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { TutorialComponent } from './tutorial/tutorial.component';
import { BizzmineTabComponent } from './bizzmine-tab/bizzmine-tab.component';
import { WikiTabComponent } from './wiki-tab/wiki-tab.component';
import { ChangelogComponent } from './changelog/changelog.component';

@NgModule({
  declarations: [
    HelpComponent,
    SupportedBrowsersComponent,
    ContactComponent,
    UnsupportedBrowserComponent,
    MaintenanceComponent,
    TutorialComponent,
    BizzmineTabComponent,
    WikiTabComponent,
    ChangelogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MonitoringModule
  ],
  exports: [
    UnsupportedBrowserComponent,
    MaintenanceComponent
  ]
})
export class HelpModule { }
